var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeactivateImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 144,
    viewBox: "0 0 141 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 81,
    r: 60,
    fill: "#F7F3FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72 128C97.9574 128 119 106.957 119 81C119 55.0426 97.9574 34 72 34C46.0426 34 25 55.0426 25 81C25 106.957 46.0426 128 72 128Z",
    fill: "#40196D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 116C91.33 116 107 100.33 107 81C107 61.67 91.33 46 72 46C52.67 46 37 61.67 37 81C37 100.33 52.67 116 72 116Z",
    fill: "#40196D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9766 92.3272V97.1055C66.9766 100.396 68.7586 101.061 70.9324 98.5939L85.757 81.7522C87.5782 79.6959 86.8145 77.9922 84.0532 77.9922H82.232",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0221 74.3108V63.8924C78.0221 60.6024 76.24 59.9366 74.0663 62.4041L59.2417 79.2458C57.4204 81.302 58.1842 83.0058 60.9454 83.0058H66.9967V85.3166",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0827 60.918L52.916 100.085",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 39,
    r: 7,
    fill: "#3CAF47"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 137,
    r: 7,
    fill: "#3CAF47"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 7,
    r: 7,
    fill: "#3CAF47"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 132,
    r: 4,
    fill: "#3CAF47"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 50,
    r: 4,
    fill: "#3CAF47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateImg);
export default __webpack_public_path__ + "static/media/deactivateImg.6134275d180fad55ca11616cf8c5b670.svg";
export { ForwardRef as ReactComponent };